import { render, staticRenderFns } from "./setDefaultSealerDialog.vue?vue&type=template&id=cd22255e&scoped=true&"
import script from "./setDefaultSealerDialog.vue?vue&type=script&lang=js&"
export * from "./setDefaultSealerDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDefaultSealerDialog.vue?vue&type=style&index=0&id=cd22255e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd22255e",
  null
  
)

export default component.exports